"use client";

import { useEffect, useState } from "react";

/**
 * Returns a value that updates `delay` ms after the input stops changing.
 * Useful for debouncing search inputs before firing server queries.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
}
